<template>
  <div class="reset-container">
    <div class="reset-wrapper">
      <!-- Left side - Image/Branding -->
      <div class="reset-left">
        <div class="brand-content">
          <div class="logo-section">
            <h1 class="brand-title">Gstocky</h1>
            <p class="brand-subtitle">{{ $t('manage_your_business') }}</p>
          </div>
          <div class="features-list">
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('inventory_management') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('crm_customer_relations') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('sales_invoicing') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('purchases_suppliers') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('point_of_sale') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('payment_management') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('attachments_documents') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('subscriptions_billing') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('and_much_more') }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right side - Reset Password Form -->
      <div class="reset-right">
        <div class="reset-form-container">
          <div class="form-header">
            <h2 class="form-title">{{ $t('reset_password') }}</h2>
            <p class="form-subtitle">{{ $t('enter_email_to_reset_password') }}</p>
          </div>

          <div v-if="sent" class="success-message">
            <div class="success-icon">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
            </div>
            <h3>{{ $t('check_your_email') }}</h3>
            <p>{{ $t('reset_link_sent_to_your_email') }}</p>
            <router-link to="/login" class="back-to-login-btn">
              {{ $t('login') }}
            </router-link>
          </div>

          <form v-else @submit.prevent="resetPassword" class="reset-form">
            <div class="form-group">
              <label for="email" class="form-label">
                {{ $t('email') }} <span class="required">*</span>
              </label>
              <div class="input-wrapper">
                <AppIcon name="bi-envelope" class="bi bi-envelope input-icon" />
                <input 
                  id="email"
                  type="email" 
                  v-model="email" 
                  :placeholder="$t('email')"
                  class="form-input"
                  @keyup.enter="resetPassword"
                  required
                />
              </div>
            </div>

            <button 
              type="submit" 
              class="reset-btn" 
              :disabled="loading"
              :class="{ 'loading': loading }"
            >
              <span v-if="loading" class="loading-spinner"></span>
              <span v-else>{{ $t('reset') }}</span>
            </button>

            <div class="links-section">
              <router-link to="/login" class="back-to-login-link">
                {{ $t('already_have_an_account') }}
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from '../helper';

export default {
  name: 'ResetPassword',
  components: {
  },
  data(){
    return {
        email : '',
        sent : false,
        loading : false
    }
  },
  mounted(){
    window.mixpanel.track("reset_password");
    document.title = 'Réinitialiser le mot de passe | Gstocky'
  },
  methods : {
    async resetPassword(){
        if(this.email == ''){
          window.vueOpener.open({
            message: 'Veuillez remplir tous les champs',
            type: 'warning',
            position : 'bottom'
          });
          return;
        }
        /* window.grecaptcha.ready(() => {
          this.loading = true
          window.grecaptcha.execute('6LetDZEmAAAAAEr9EdTVoDeg6-saEQYhXVSlrQhO', {action: 'submit'})
              .then( async (token) => {
                if(token){ */
                     try{
                      this.sent = false
                      this.loading = true
                      await helper.customPost(`${process.env.VUE_APP_API}/reset`,
                      {
                        email : this.email, 
                        // token
                      })
                      this.loading = false
                      this.email = ''
                      this.sent = true

                    }catch(error){
                      this.loading = false
                    }
                /* }
              })
              .catch(() => {
                this.loading = true
              })
        }) */
       
    },
    
  }
}
</script>

<style scoped> 
.reset-container {
  min-height: 100vh;
  /* background: #004aad; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.reset-wrapper {
  display: flex;
  max-width: 1200px;
  width: 100%;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(1, 75, 173, 0.15);
}

.reset-left {
  flex: 1;
  background: #004aad;
  color: white;
  padding: 60px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-content {
  text-align: center;
}

.brand-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 10px;
  background: linear-gradient(45deg, #fff, #e6f0ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-subtitle {
  font-size: 1.2rem;
  margin-bottom: 40px;
  opacity: 0.9;
}

.features-list {
  text-align: left;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 1.1rem;
}

.feature-item .app-lucide-icon {
  color: #00d4aa;
  flex: 0 0 auto;
  font-size: 1.3rem;
}

.reset-right {
  flex: 1;
  padding: 60px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reset-form-container {
  width: 100%;
  max-width: 400px;
}

.form-header {
  text-align: center;
  margin-bottom: 40px;
}

.form-title {
  font-size: 2rem;
  font-weight: 700;
  color: #004aad;
  margin-bottom: 10px;
}

.form-subtitle {
  color: #6b7280;
  font-size: 1rem;
}

.success-message {
  text-align: center;
  padding: 40px 20px;
}

.success-icon {
  font-size: 4rem;
  color: #00d4aa;
  margin-bottom: 20px;
}

.success-message h3 {
  font-size: 1.5rem;
  color: #004aad;
  margin-bottom: 10px;
}

.success-message p {
  color: #6b7280;
  margin-bottom: 30px;
}

.back-to-login-btn {
  background: #004aad;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: none;
  display: inline-block;
  transition: background-color 0.3s;
}

.back-to-login-btn:hover {
  background: #004aad;
}

.reset-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.required {
  color: #ef4444;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #004aad;
  font-size: 1.1rem;
}

.form-input {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s;
  background: #f9fafb;
}

.form-input:focus {
  outline: none;
  border-color: #004aad;
  background: white;
  box-shadow: 0 0 0 3px rgba(1, 75, 173, 0.1);
}

.reset-btn {
  background: #004aad;
  color: white;
  border: none;
  padding: 16px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reset-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(1, 75, 173, 0.3);
}

.reset-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.links-section {
  text-align: center;
  margin-top: 20px;
}

.back-to-login-link {
  color: #004aad;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s;
}

.back-to-login-link:hover {
  color: #0056d6;
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .reset-wrapper {
    flex-direction: column;
    max-width: 100%;
    border-radius: 0;
  }

  .reset-left {
    padding: 40px 20px;
  }

  .reset-right {
    padding: 40px 20px;
  }

  .brand-title {
    font-size: 2.5rem;
  }

  .form-title {
    font-size: 1.8rem;
  }

  .features-list {
    display: none;
  }
}

@media (max-width: 480px) {
  .reset-container {
    padding: 10px;
  }

  .reset-left,
  .reset-right {
    padding: 30px 15px;
  }

  .brand-title {
    font-size: 2rem;
  }

  .form-title {
    font-size: 1.5rem;
  }
}
</style>
